import { Tooltip, Box, Typography, IconButton, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import Iconify from '../../Iconify';
import useLocales from '../../../hooks/useLocales';

ArticleCoTooltip.propTypes = {
  name: PropTypes.string,
  year: PropTypes.string,
  author: PropTypes.string,
  link: PropTypes.string,
};

export default function ArticleCoTooltip({ name, year, author, link }) {
  const { translate } = useLocales();
  return (
    <Tooltip
      placement="top-start"
      leaveDelay={500}
      enterTouchDelay={0}
      leaveTouchDelay={10000}
      title={
        <Box display="inline-flex" flexDirection="column" alignItems="flex-start" sx={{ padding: '20px' }}>
          <Typography variant="body1" color="common.white" fontWeight="700">
            {name}
          </Typography>
          {!!author && (
            <Typography variant="body2" color="common.white" sx={{ mt: 2 }}>
              {author}
            </Typography>
          )}
          {!!year && (
            <Typography variant="body2" color="common.white" sx={{ mt: 2 }}>
              {year}
            </Typography>
          )}
          <Link
            to={link}
            component={RouterLink}
            sx={{ textDecoration: 'underline', cursor: 'pointer', color: 'primary.main', mt: 2 }}
          >
            {translate('default.showMore')}
          </Link>
        </Box>
      }
      sx={{ display: 'block', ml: 'auto' }}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'grey.700',
          },
        },
      }}
    >
      <IconButton
        aria-label="info-co"
        sx={{ alignItems: 'flex-end', bottom: { xs: '22%', sm: '15%', md: '15%' }, right: '1%' }}
      >
        <Iconify
          icon="ant-design:info-circle-outlined"
          color="white"
          height={34}
          width={34}
          sx={{ display: 'block' }}
        />
      </IconButton>
    </Tooltip>
  );
}
